import React, { FC } from 'react';

export const Disclaimer: FC = ({ children }) => {
  return <div className='text-gray-500 text-sm'>{children}</div>;
};
